import {getRoomConfig} from "./room";

let place = getRoomConfig('场所');
place.init.type = 2;
place.query = '&sort=order,-id&filter[type]=2';

export default place;
